<script>
/**
 * @overview 全局复用交互icon组件
 *
 * @author huojinzhao
 */

export default {
  name: "AppIcon",

  props: {
    type: {
      type: String,
      required: true,
    },

    element: {
      type: String,
      default: "i",
    },

    isJinyong: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({

  }),

  computed: {
    targetType() {
      return this.typeMap[this.type];
    },
    typeMap() {
      return {
        edit: {
          state: "primary",
          title: "编辑",
        },
        delete:
        {
          state: "warning",
          title: "删除",
        },
        preview: {
          state: "success",
          title: "预览",
        },
        import:
        {
          state: "primary",
          title: "导入",
        },
        download: {
          state: "primary",
          title: "下载",
        },
        fuzhi: {
          state: "primary",
          title: "复制",
        },
        move: {
          state: "primary",
          title: "移动",
        },
        jinyong: {
          state: "primary",
          title: !this.isJinyong ? '启用' : '禁用',
        },
        label: {
          state: "primary",
          title: "标签",
        },
      };
    },
  },

  methods: {
    iconClick(e) {
      this.$emit("click", e);
    },
  },
};
</script>

<template>
  <component
    :is="element"
    :class="`
      app-icon
      iconfont
      icon-${type}
      state-${targetType.state}-icon
    `"
    :title="targetType.title"
    @click="iconClick"
  />
</template>

<style lang="postcss" scoped>
.app-icon {
  cursor: pointer;
}
.iconfont{
  margin-left: 12px !important;
  margin-right: 12px !important;
  font-size: 30px;
}
</style>
